module.exports = __webpack_public_path__ + "6358ba16cf78dbe9d7969f9d673a7b92.pdf";